import enviro from 'enviro';
import Raven from 'raven-js';
export const getHostAppName = () => {
  try {
    var _window$top$hubspot$b, _window$top;
    // @ts-ignore - No bender type in the hubspot window object
    return (_window$top$hubspot$b = (_window$top = window.top) === null || _window$top === void 0 || (_window$top = _window$top.hubspot) === null || _window$top === void 0 || (_window$top = _window$top.bender) === null || _window$top === void 0 ? void 0 : _window$top.currentProject) !== null && _window$top$hubspot$b !== void 0 ? _window$top$hubspot$b : null;
  } catch (e) {
    if (enviro.deployed()) {
      Raven.captureException(new Error('Failed to get host app name from bender', {
        cause: e
      }), {
        extra: {
          e
        }
      });
    }

    // Cross-origin access fails locally; return fallback
    return null;
  }
};